import React from 'react';
import NewspaperIcon from '@heroicons/react/outline/NewspaperIcon.js';
import { PostListOrderByEnum } from '@tribeplatform/gql-client/types';
import { BlockType } from '../../types/index.js';
import { FeedBlock as Component } from './Block.js';
import { FeedBlockSettings as Settings } from './Settings.js';
export const RegisteredFeedBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'Feed',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({ id: 'Generics.Feed', defaultMessage: 'Feed' }),
            Settings,
            Icon: React.createElement(NewspaperIcon, null),
            defaultProps: {
                view: 'card',
                orderBy: PostListOrderByEnum.publishedAt,
            },
        },
    };
};
//# sourceMappingURL=registered.js.map